var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wout-principal"},[_c('div',{staticClass:"center"},[_c('div',[_c('img',{attrs:{"src":require("@/assets/img/processandopgto.svg"),"width":"auto","height":"130","alt":"Processando pagamento...","crossorigin":""}})]),_c('span',{staticClass:"processando"},[_vm._v("Processando Pagamento...")])])])
}]

export { render, staticRenderFns }